import React from "react";
import { propTypes } from "react-bootstrap/esm/Image";
import { CAlert, CCol, CRow } from "@coreui/react";
import "../dataset-style.scss";
export function ScoredDataError() {
  return (
    <CRow>
      <CCol xs="12" md="12">
        <CAlert color="warning" className="scored-data-error">
          <p>
            To enable the <b>&apos;Cluster Analytics&apos;</b> and{" "}
            <b>&apos;Export&apos;</b> features, please score at least one record
            for this dataset.
          </p>
        </CAlert>
      </CCol>
    </CRow>
  );
}

ScoredDataError.propTypes = {
  status: propTypes.string,
};
